import { TableCell, TableHead, TableRow } from "@mui/material";

export const TableHeader = () => {
	return (
		<TableHead>
			<TableRow>
				<TableCell align='left'>{"Name"}</TableCell>
				<TableCell align='center'>{"ISIN"}</TableCell>
				<TableCell align='center'>{"Moneda"}</TableCell>
				<TableCell align='center'>{"Mercado"}</TableCell>
				<TableCell align='left'>{"Acción"}</TableCell>
				<TableCell align='center'>{""}</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default TableHeader;
